
export class AppStatusEvent {

  private readonly id: string;
  private readonly message: string;
  private readonly priority: number;

  constructor(id: string, message: string, priority: number) {
    this.id = id;
    this.message = message;
    this.priority = priority;
  }

  getId(): string {
    return this.id;
  }

  getMessage(): string {
    return this.message;
  }

  getPriority(): number {
    return this.priority;
  }
}
